module.exports = __webpack_public_path__ + "static/media/tick.4f1ad018.svg";